/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type SavedSearchTabEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const savedSearchTabEntryPoint: EntryPoint<SavedSearchTabEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<SavedSearchTabEntryPointComponent>(
			/* webpackChunkName: "async-assets-object-class-view-saved-search-tab" */ './SavedSearchPanel.tsx',
		),
		getPreloadProps: () => ({
			extraProps: {},
		}),
	});
